<template>
  <div class="mobile-nav only-mobile" :class="getClass">
    <MobileLogo :isBackgroundPrimary="isBackgroundPrimary" :screenLevel="screenLevel" />
    <HamburgerIcon
      :isBackgroundPrimary="isBackgroundPrimary"
      :isMobileNavOpen="true"
      :screenLevel="screenLevel"
    />
    <ul class="mobile-nav__buttons">
      <li class="mobile-nav__button" @click="hideNav">
        <TheButton size="medium" text="Poznaj Punkty" icon="arrow.png" link="#posts-list" />
      </li>
      <li class="mobile-nav__button">
        <TheButton
          size="medium"
          text="Pobierz Raport"
          icon="arrow-two-fingers-primary.svg"
          link="./report-pl.pdf"
          :openInNewTab="true"
        />
      </li>
      <li class="mobile-nav__button" @click="contactPanelHandler">
        <TheButton size="medium" text="Kontakt" icon="open-hand.svg" />
      </li>
      <li class="mobile-nav__button">
        <TheButton size="medium" text="English" icon="lang-mobile-icon.svg" link="/en" />
      </li>
    </ul>
  </div>
</template>

<script>
import { bus } from "../../main";
import TheButton from "../TheButton";
import MobileLogo from "./MobileLogo";
import HamburgerIcon from "./HamburgerIcon";

export default {
  name: "MobileNavPanel",
  components: {
    TheButton,
    MobileLogo,
    HamburgerIcon
  },
  props: {
    isMobileNavOpen: Boolean,
    isBackgroundPrimary: Boolean,
    screenLevel: String,
    isPolicyPrivacyOpen: Boolean,
    isPostActive: Boolean
  },
  methods: {
    hideNav() {
      bus.$emit("mobileNavClickHandler", true, true);
    },
    contactPanelHandler() {
      bus.$emit("contactPanelHandler");
    }
  },
  computed: {
    getClass() {
      let output = "";

      if (this.isMobileNavOpen) {
        output += " mobile-nav--active";
      }

      if (
        (!this.isBackgroundPrimary || this.screenLevel === "bottom") &&
        !this.isPostActive &&
        !this.isPolicyPrivacyOpen
      ) {
        output += " mobile-nav--white";
      }

      return output;
    }
  }
};
</script>

<style lang="scss">
.mobile-nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex !important;
  flex-direction: column;
  justify-content: space-between;
  background-color: $primary-color;
  transform: translateY(-100%);
  z-index: 30;
  transition: 0.4s ease-in-out;
  padding: 26px 6% 34px;

  &--active {
    transform: translateY(0);
  }

  &--white {
    background-color: #fff;
  }

  &__buttons {
    padding-left: 32px;
  }

  .button {
    margin-top: 30px;
  }

  .hamburger {
    position: absolute;
    top: 26px;
    right: 6%;
    margin-top: 0;
  }
}
</style>